import React from 'react';

import { useCellScope } from '@/contexts/CellScopeContext';

const containerStyle: React.CSSProperties = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 8,
  padding: '8px 16px',
  borderBottom: '1px solid #e5e7eb',
  background: '#f8fafc',
  fontFamily: 'Inter, sans-serif',
};

const labelStyle: React.CSSProperties = {
  fontSize: 12,
  fontWeight: 600,
  color: '#334155',
};

const helpStyle: React.CSSProperties = {
  fontSize: 11,
  color: '#64748b',
};

export default function CellScopeSelector() {
  const { cellId, setCellId, availableCellIds } = useCellScope();

  return (
    <div style={containerStyle} data-testid="cell-scope-selector">
      <span style={labelStyle}>Cell scope</span>
      <select
        aria-label="Cell scope"
        value={cellId}
        onChange={(event) => setCellId(event.target.value)}
      >
        {availableCellIds.map((id) => (
          <option key={id} value={id}>
            {id}
          </option>
        ))}
      </select>
      <span style={helpStyle}>Sent as X-Cell-Id on control-plane API calls</span>
    </div>
  );
}
